import React from 'react';
import { UploadMediaToReadingPanelView } from './UploadMediaToReadingPanelView';
import { Reading } from 'util/backendapi/types/Model';

export type UploadMediaToReadingPanelProps = {
  reading: Reading;
  timeZone: string | null | undefined;
  hidePanel: () => void;
  onMediaUploaded: () => void;
};

export function UploadMediaToReadingPanel(
  props: UploadMediaToReadingPanelProps
) {
  const { hidePanel, onMediaUploaded } = props;

  return (
    <UploadMediaToReadingPanelView
      {...props}
      onAfterSubmit={() => {
        onMediaUploaded();
        hidePanel();
      }}
      onCancel={hidePanel}
    />
  );
}
